import { take } from 'lodash'

const materialColors = [
  '#3366CC',
  '#DC3912',
  '#FF9900',
  '#109618',
  '#990099',
  '#3B3EAC',
  '#0099C6',
  '#DD4477',
  '#66AA00',
  '#B82E2E',
  '#316395',
  '#994499',
  '#22AA99',
  '#AAAA11',
  '#6633CC',
  '#E67300',
  '#8B0707',
  '#329262',
  '#5574A6',
  '#3B3EAC'
]

export default {
  materialAt (index: number) {
    return materialColors[index]
  },

  staticMaterialList (length: number) {
    return take(materialColors, length % materialColors.length)
  }
}
